function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-516.000000, -3062.000000)"
}, React.createElement("g", {
  transform: "translate(105.000000, 2705.000000)"
}, React.createElement("g", {
  transform: "translate(303.000000, 357.000000)"
}, React.createElement("g", {
  transform: "translate(108.000000, 0.000000)"
}, React.createElement("circle", {
  stroke: "#FFFFFF",
  cx: 19,
  cy: 19,
  r: 18.5
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "14.4055677 27.3125 10.9623362 27.3125 10.9623362 16.2049219 14.4107533 16.2049219 14.4107533 27.3125"
}), React.createElement("path", {
  d: "M12.683952,14.6878906 C11.5794214,14.6878906 10.6875,13.7891016 10.6875,12.6876953 C10.6875,11.5862891 11.5794214,10.6875 12.683952,10.6875 C13.7832969,10.6875 14.6804039,11.5862891 14.6804039,12.6876953 C14.6804039,13.7942969 13.7884825,14.6878906 12.683952,14.6878906 L12.683952,14.6878906 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M27.3125,27.3125 L23.8692686,27.3125 L23.8692686,21.909375 C23.8692686,20.6209375 23.8433406,18.9636328 22.0802402,18.9636328 C20.2860262,18.9636328 20.01119,20.3663672 20.01119,21.8158594 L20.01119,27.3125 L16.5679585,27.3125 L16.5679585,16.2049219 L19.871179,16.2049219 L19.871179,17.7219531 L19.9178493,17.7219531 C20.3793668,16.8491406 21.5046397,15.9295703 23.1795852,15.9295703 C26.6643013,15.9295703 27.3125,18.2310937 27.3125,21.2235937 L27.3125,27.3125 L27.3125,27.3125 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.9dbf3d50.svg";
export { SvgComponent as ReactComponent };